import React, { useState } from "react";
import { Container } from "./styles";
import { useWallet } from "../../../../hooks/useWallet";

const ConnectWalletButton = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { currentWallet, setCurrentWallet, connectMetaMask } = useWallet();
  // const handleClick = async () => {
  //   // setIsOpenModal(true)
  //   console.log("Resquesting account...");

  //   if (window.ethereum) {
  //     console.log("Meta Mask detected");
  //     try {
  //       const accounts = await window.ethereum.request({
  //         method: "eth_requestAccounts",
  //       });
  //       setCurrentWallet(accounts[0]);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   } else {
  //     console.log("Meta Mask not detected");
  //   }
  // };
  return (
    <Container onClick={connectMetaMask}>
      {currentWallet
        ? currentWallet.length > 12
          ? currentWallet.substr(0, 5) +
            "..." +
            currentWallet.substr(currentWallet.length - 5, currentWallet.length)
          : currentWallet
        : "Connect Wallet"}
    </Container>
  );
};

export default ConnectWalletButton;
